self["MonacoEnvironment"] = (function (paths) {
      function stripTrailingSlash(str) {
        return str.replace(/\/$/, '');
      }
      return {
        globalAPI: true,
        getWorkerUrl: function (moduleId, label) {
          var pathPrefix = typeof __webpack_public_path__ === 'string' ? __webpack_public_path__ : "";
          var result = (pathPrefix ? stripTrailingSlash(pathPrefix) + '/' : '') + paths[label];
          if (/^((http:)|(https:)|(file:)|(\/\/))/.test(result)) {
            var currentUrl = String(window.location);
            var currentOrigin = currentUrl.substr(0, currentUrl.length - window.location.hash.length - window.location.search.length - window.location.pathname.length);
            if (result.substring(0, currentOrigin.length) !== currentOrigin) {
              if(/^(\/\/)/.test(result)) {
                result = window.location.protocol + result
              }
              var js = '/*' + label + '*/importScripts("' + result + '");';
              var blob = new Blob([js], { type: 'application/javascript' });
              return URL.createObjectURL(blob);
            }
          }
          return result;
        }
      };
    })({
  "editorWorkerService": "editor.worker.js",
  "css": "css.worker.js",
  "html": "html.worker.js",
  "json": "json.worker.js",
  "typescript": "ts.worker.js",
  "javascript": "ts.worker.js",
  "less": "css.worker.js",
  "scss": "css.worker.js",
  "handlebars": "html.worker.js",
  "razor": "html.worker.js"
});
require("./standalone/browser/accessibilityHelp/accessibilityHelp.js");
require("./contrib/anchorSelect/browser/anchorSelect.js");
require("./contrib/bracketMatching/browser/bracketMatching.js");
require("./browser/coreCommands.js");
require("./contrib/caretOperations/browser/caretOperations.js");
require("./contrib/caretOperations/browser/transpose.js");
require("./contrib/clipboard/browser/clipboard.js");
require("./contrib/codeAction/browser/codeActionContributions.js");
require("./contrib/codelens/browser/codelensController.js");
require("./contrib/colorPicker/browser/colorContributions.js");
require("./contrib/comment/browser/comment.js");
require("./contrib/contextmenu/browser/contextmenu.js");
require("./contrib/cursorUndo/browser/cursorUndo.js");
require("./contrib/dnd/browser/dnd.js");
require("./contrib/documentSymbols/browser/documentSymbols.js");
require("./contrib/find/browser/findController.js");
require("./contrib/folding/browser/folding.js");
require("./contrib/fontZoom/browser/fontZoom.js");
require("./contrib/format/browser/formatActions.js");
require("./contrib/gotoError/browser/gotoError.js");
require("./standalone/browser/quickAccess/standaloneGotoLineQuickAccess.js");
require("./contrib/gotoSymbol/browser/goToCommands.js");
require("./contrib/gotoSymbol/browser/link/goToDefinitionAtPosition.js");
require("./contrib/hover/browser/hover.js");
require("./standalone/browser/iPadShowKeyboard/iPadShowKeyboard.js");
require("./contrib/inPlaceReplace/browser/inPlaceReplace.js");
require("./contrib/indentation/browser/indentation.js");
require("./contrib/inlayHints/browser/inlayHintsContribution.js");
require("./contrib/inlineCompletions/browser/inlineCompletionsContribution.js");
require("./standalone/browser/inspectTokens/inspectTokens.js");
require("./contrib/lineSelection/browser/lineSelection.js");
require("./contrib/linesOperations/browser/linesOperations.js");
require("./contrib/linkedEditing/browser/linkedEditing.js");
require("./contrib/links/browser/links.js");
require("./contrib/multicursor/browser/multicursor.js");
require("./contrib/parameterHints/browser/parameterHints.js");
require("./standalone/browser/quickAccess/standaloneCommandsQuickAccess.js");
require("./standalone/browser/quickAccess/standaloneHelpQuickAccess.js");
require("./standalone/browser/quickAccess/standaloneGotoSymbolQuickAccess.js");
require("./standalone/browser/referenceSearch/standaloneReferenceSearch.js");
require("./contrib/rename/browser/rename.js");
require("./contrib/smartSelect/browser/smartSelect.js");
require("./contrib/snippet/browser/snippetController2.js");
require("./contrib/suggest/browser/suggestController.js");
require("./standalone/browser/toggleHighContrast/toggleHighContrast.js");
require("./contrib/toggleTabFocusMode/browser/toggleTabFocusMode.js");
require("./contrib/tokenization/browser/tokenization.js");
require("./contrib/unicodeHighlighter/browser/unicodeHighlighter.js");
require("./contrib/unusualLineTerminators/browser/unusualLineTerminators.js");
require("./contrib/viewportSemanticTokens/browser/viewportSemanticTokens.js");
require("./contrib/wordHighlighter/browser/wordHighlighter.js");
require("./contrib/wordOperations/browser/wordOperations.js");
require("./contrib/wordPartOperations/browser/wordPartOperations.js");
module.exports = require("!!./editor.api.js");
require("../basic-languages/abap/abap.contribution.js");
require("../basic-languages/apex/apex.contribution.js");
require("../basic-languages/azcli/azcli.contribution.js");
require("../basic-languages/bat/bat.contribution.js");
require("../basic-languages/bicep/bicep.contribution.js");
require("../basic-languages/cameligo/cameligo.contribution.js");
require("../basic-languages/clojure/clojure.contribution.js");
require("../basic-languages/coffee/coffee.contribution.js");
require("../basic-languages/cpp/cpp.contribution.js");
require("../basic-languages/csharp/csharp.contribution.js");
require("../basic-languages/csp/csp.contribution.js");
require("../basic-languages/css/css.contribution.js");
require("../language/css/monaco.contribution.js");
require("../basic-languages/dart/dart.contribution.js");
require("../basic-languages/dockerfile/dockerfile.contribution.js");
require("../basic-languages/ecl/ecl.contribution.js");
require("../basic-languages/elixir/elixir.contribution.js");
require("../basic-languages/flow9/flow9.contribution.js");
require("../basic-languages/freemarker2/freemarker2.contribution.js");
require("../basic-languages/fsharp/fsharp.contribution.js");
require("../basic-languages/go/go.contribution.js");
require("../basic-languages/graphql/graphql.contribution.js");
require("../basic-languages/handlebars/handlebars.contribution.js");
require("../basic-languages/hcl/hcl.contribution.js");
require("../basic-languages/html/html.contribution.js");
require("../language/html/monaco.contribution.js");
require("../basic-languages/ini/ini.contribution.js");
require("../basic-languages/java/java.contribution.js");
require("../basic-languages/javascript/javascript.contribution.js");
require("../language/json/monaco.contribution.js");
require("../basic-languages/julia/julia.contribution.js");
require("../basic-languages/kotlin/kotlin.contribution.js");
require("../basic-languages/less/less.contribution.js");
require("../basic-languages/lexon/lexon.contribution.js");
require("../basic-languages/liquid/liquid.contribution.js");
require("../basic-languages/lua/lua.contribution.js");
require("../basic-languages/m3/m3.contribution.js");
require("../basic-languages/markdown/markdown.contribution.js");
require("../basic-languages/mips/mips.contribution.js");
require("../basic-languages/msdax/msdax.contribution.js");
require("../basic-languages/mysql/mysql.contribution.js");
require("../basic-languages/objective-c/objective-c.contribution.js");
require("../basic-languages/pascal/pascal.contribution.js");
require("../basic-languages/pascaligo/pascaligo.contribution.js");
require("../basic-languages/perl/perl.contribution.js");
require("../basic-languages/pgsql/pgsql.contribution.js");
require("../basic-languages/php/php.contribution.js");
require("../basic-languages/pla/pla.contribution.js");
require("../basic-languages/postiats/postiats.contribution.js");
require("../basic-languages/powerquery/powerquery.contribution.js");
require("../basic-languages/powershell/powershell.contribution.js");
require("../basic-languages/protobuf/protobuf.contribution.js");
require("../basic-languages/pug/pug.contribution.js");
require("../basic-languages/python/python.contribution.js");
require("../basic-languages/qsharp/qsharp.contribution.js");
require("../basic-languages/r/r.contribution.js");
require("../basic-languages/razor/razor.contribution.js");
require("../basic-languages/redis/redis.contribution.js");
require("../basic-languages/redshift/redshift.contribution.js");
require("../basic-languages/restructuredtext/restructuredtext.contribution.js");
require("../basic-languages/ruby/ruby.contribution.js");
require("../basic-languages/rust/rust.contribution.js");
require("../basic-languages/sb/sb.contribution.js");
require("../basic-languages/scala/scala.contribution.js");
require("../basic-languages/scheme/scheme.contribution.js");
require("../basic-languages/scss/scss.contribution.js");
require("../basic-languages/shell/shell.contribution.js");
require("../basic-languages/solidity/solidity.contribution.js");
require("../basic-languages/sophia/sophia.contribution.js");
require("../basic-languages/sparql/sparql.contribution.js");
require("../basic-languages/sql/sql.contribution.js");
require("../basic-languages/st/st.contribution.js");
require("../basic-languages/swift/swift.contribution.js");
require("../basic-languages/systemverilog/systemverilog.contribution.js");
require("../basic-languages/tcl/tcl.contribution.js");
require("../basic-languages/twig/twig.contribution.js");
require("../basic-languages/typescript/typescript.contribution.js");
require("../language/typescript/monaco.contribution.js");
require("../basic-languages/vb/vb.contribution.js");
require("../basic-languages/xml/xml.contribution.js");
require("../basic-languages/yaml/yaml.contribution.js");